import type { Entity } from "@common/types/entity";

/** What an entity's avatar is called, so an unnamed entity is not announced as "". */
export const getEntityAvatarName = (entity: Pick<Entity, "name">) =>
    entity.name ?? "Unnamed entity";
